import api from '../../../api'
import { executeResponseError } from '../../../helpers'

export const USER_SET = 'USER_SET'
export const USER_JSON_SET = 'USER_JSON_SET'
export const USER_RISK_DATA_SET = 'USER_RISK_DATA_SET'
export const DEFAULT_RISKDATA_SET = 'DEFAULT_RISKDATA_SET'
export const LOGOUT = 'LOGOUT'
export const USER_MSGS_SET = 'USER_MSGS_SET'


export const getUser = (token) => {
	return async (dispatch, getState) => {
		const apiVersion = getState().appReducer.user?.userJson?.platform?.trading?.version
		try {
			const res = await api.user.getUserApi(token, apiVersion)
			if (res?.data) dispatch(setUser(res.data))
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Get user data error')
			throw new Error(error || '')
		}
	}
}

export const setThemeAction = (theme, token) => {
	return async dispatch => {
		try {
			const res = await api.user.setTheme(theme, token)
			if (res?.data) dispatch(setUser(res.data))
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Set theme error')
			throw new Error(error || '')
		}
	}
}

export const setUser = (user) => {
	return {
		payload: user,
		type: USER_SET
	}
}
export const logOut = () => {
	return {
		type: LOGOUT
	}
}

export const getJsonAction = (token, lang) => {
	return async dispatch => {
		try {
			const res = await api.user.getJson(token, lang)
			if (res?.data) {
				dispatch(setJsonAction(res.data))
				localStorage.setItem('trading-pricer', JSON.stringify(res?.data?.platform?.pricer))
				return res?.data?.platform?.pricer
			}
		} catch (e) {
			const error = executeResponseError(e, 'Get json data error')
			throw new Error(error || '')
		}
	}
}


export const deleteMsgAction = (id, token) => {
	return async dispatch => {
		try {
			const res = await api.user.deleteMsg(id, token)
			if (res?.data) {
				dispatch(getMsgsAction(token))
			}
		} catch (e) {
			const error = executeResponseError(e, 'Delete msg error')
			throw new Error(error || '')
		}
	}
}
export const getMsgsAction = (token) => {
	return async dispatch => {
		try {
			const res = await api.user.getMsgs(token)
			if (res?.data) {
				dispatch({
					payload: res?.data,
					type: USER_MSGS_SET
				})
			}
		} catch (e) {
			const error = executeResponseError(e, 'Get msg error')
			throw new Error(error || '')
		}
	}
}
export const setRiskData = (data) => {
	return {
		payload: data,
		type: USER_RISK_DATA_SET
	}
}

export const setJsonAction = (json) => {
	return dispatch => {
		dispatch({
			payload: json,
			type: USER_JSON_SET
		})
		dispatch(setDefaultRiskData(json))
	}
}
export const setDefaultRiskData = (json) => {
	return {
		payload: json,
		type: DEFAULT_RISKDATA_SET
	}
}

